import axios from "axios";

export interface ILiveConference {
  conference: string;
  guest_call_sid: string;
  guest_from: string;
  guest_to: string;
  agent_id: string;
  company_id: string;
  domain: string;
  started_at: string;
}

export const getLiveConferences = async () => {
  const res = await axios.get<{
    data: { conferences: ILiveConference[] };
  }>("/conference");
  return res;
};

export const getMonitorToken = async (conference: string) => {
  const res = await axios.post<{
    data: { token: string; identity: string; conference: string };
  }>("/conference/monitor-token", { conference });
  return res;
};
